import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { PaginatedColocApiConnectedDropDown } from '@/features/shared/feature-paginated-coloc-api-connected-dropdown';
import { House } from '@/types/admin';
import { useGetHousesInfinite } from '@/features/shared/hooks/use-get-houses-infinite';

interface HouseSelectionDropdownProps {
  selectedHouse: House | null;
  setSelectedHouse: (house: House | null) => void;
  housesQuery: string;
  setHousesQuery: (query: string) => void;
}

const HouseSelectionDropdown: React.FC<HouseSelectionDropdownProps> = ({
  selectedHouse,
  setSelectedHouse,
  housesQuery,
  setHousesQuery,
}) => {
  const { t } = useTranslation();

  const housesDataSource = useGetHousesInfinite({
    searchQuery: housesQuery,
    household: true
  });

  // Ensure value is always null or a House object
  const dropdownValue = selectedHouse || null;

  return (
    <PaginatedColocApiConnectedDropDown<House>
      placeholder={t('js.features.admin.transactions.create_payment_modal.house_placeholder') ?? ''}
      className="z-[90]"
      showLabel
      label={t('js.features.admin.transactions.create_payment_modal.house_label')}
      value={dropdownValue}
      onChange={setSelectedHouse}
      {...(dropdownValue && {
        displayValue: dropdownValue.name,
      })}
      onTextInputChange={(event) => setHousesQuery(event.target.value)}
      dataSource={housesDataSource}
      itemRenderer={(itemProps, ref) => (
        <DropDown.DropDownOptionDefaultContent ref={ref}>
          {itemProps.name}
        </DropDown.DropDownOptionDefaultContent>
      )}
    />
  );
};

export { HouseSelectionDropdown };
